import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_LOGIN, ROUTE_MENU } from "../../constants";
import { useAuthState } from "../../context/UserAuthentication";
import { HandleFallBackUrlsContext } from '../../context/HandleFallBackUrlsContext';
import Spinner from "../Spinner/Spinner";
import { useAppSelector } from "../../redux/store/store";

interface PrivateRouteProps {
    Component: React.ComponentType<any>;
}

const RequireAuthAndCart: React.FC<PrivateRouteProps> = ({ Component }) => {
    const location = useLocation();
    const { authInfo } = useAuthState();
    const { handleFallBackUrlsLoading } = useContext(HandleFallBackUrlsContext);
    const cart = useAppSelector((state) => state.cart.items);
    if (handleFallBackUrlsLoading) {
        return <Spinner lightBg={true} />;
    }

    const element =  (() => {
        if (!Array.isArray(cart) || cart?.length === 0) {
            return <Navigate to={ROUTE_MENU} state={{ referrer: location.pathname }} replace />;
        }
        return <Component />;
    })();

    return element;
};

export default RequireAuthAndCart;
